@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.spinner {
  display: inline-block;
  flex-shrink: 0;
  border: 2px solid currentColor;
  border-inline-end-color: transparent;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

.sm {
  composes: spinner;
  width: 1rem;
  height: 1rem;
}

.md {
  composes: spinner;
  width: 1.25rem;
  height: 1.25rem;
}

.lg {
  composes: spinner;
  width: 2rem;
  height: 2rem;
  border-width: 3px;
}
